import { Button, styled } from "@mui/material";
import React from "react";

const StyledTab = styled(Button)(({ theme }: any) => ({
  border: `1px solid ${theme.palette.common.borderGrey}`,
  color: "#000",
  backgroundColor: theme.palette.common.white,

  "& :hover,:focus,:active": {
    backgroundColor: theme.palette.common.green,
  },
}));

const TabVisual = ({ onClick, label }: any) => {
  return <StyledTab onClick={onClick}>{label}</StyledTab>;
};

export default TabVisual;
